const navIconBurger = document.querySelector(".nav-icon-burger");
const navPanel = document.querySelector(".nav-panel");

navIconBurger.addEventListener("click", function () {
  navPanel.classList.toggle("nav-panel-shown");
  navIconBurger.classList.toggle("nav-icon-burger-opened");
});
